export enum CabinetStatus {
  STOPPED,
  STARTED,
  IN_PROGRESS,
}
